import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
const LoginActionLogin = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [selectedRows, setSelectedRows] = useState([])
    const [bulkAction, setBulkAction] = useState("-1")
    const [logins, setLogins] = useState([])
    const [filteredLogins, setFilteredLogins] = useState([])
    const [roleList, setRoleList] = useState([])
    const [activeRole, setActiveRole] = useState('')
    const [searchQuery, setSearchQuery] = useState('')
    const [reloadLogins, setReloadLogins] = useState(0)
    
    const columns = [
        {
            id: 'username',
            name: __('Username', 'ultimate-security'),
            cell: row => (
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <img src={row.avatar} alt={row.username} width="40" height="40" />
                    <span><b>{row.username}</b></span>
                </div>
            ),
        },
        {
            id: 'email',
            name: __('Email', 'ultimate-security'),
            selector: row => row.email,
            sortable: true,
        },
        {
            id: 'role',
            name: __('Role', 'ultimate-security'),
            selector: row => row.role,
            sortable: true,
        },
        {
            id: 'remote-ip',
            name: __('Remote IP', 'ultimate-security'),
            selector: row => row.remote_ip,
            sortable: true,
        },
        {
            id: 'device',
            name: __('Device', 'ultimate-security'),
            selector: row => row.device,
            sortable: true,
        },
        {
            id: 'os',
            name: __('OS', 'ultimate-security'),
            selector: row => row.os,
            sortable: true,
        },
        {
            id: 'client',
            name: __('Client', 'ultimate-security'),
            selector: row => row.client,
            sortable: true,
        },
        {
            id: 'login',
            name: __('Login', 'ultimate-security'),
            selector: row => row.login,
            sortable: true,
        },
        {
            id: 'login-activity',
            name: __('Login Activity', 'ultimate-security'),
            cell: row => (
                <div className="login-activity-wrap">
                    <div className="login-details">
                        <span className="time-ago">{row.login_activity.time_ago}</span>
                        <img
                            data-token={row.token}
                            title={__("Logout", 'ultimate-security')}
                            src={ultimate_security_ajax_obj.imageUrl + 'logout.svg'}
                            role="button"
                            onClick={() => handleClickForceLogout(row.user_id, row.token)}
                        />
                    </div>
                    <span className="formated-time">{row.login_activity.timestamp}</span>
                </div>
            ),
            ignoreRowClick: true,
            allowoverflow: true,
            button: true,
            minwidth: "250px",
            style: { display: 'flex', justifyContent: 'end', paddingRight: '11px' },
        }
    ];

    // Get roles data
    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getRoleData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-session-roles`,
                    method: 'GET'
                });
        
                const rolesArray = Object.entries(response).map(([key, value]) => ({
                    role: key,
                    ...value
                }));
        
                setRoleList(rolesArray);
        
            } catch (error) {
                console.log(error);
            }
        };
        getRoleData();
    }, [])
    
    // Get active logins data
    useEffect(() => {        
        setSearchQuery('');
        const getActiveLogins = async () => {
            try {
                const response = await apiFetch({
                    path: '/ultimate-security/v1/active-logins',
                    method: 'GET'
                });    
                setLogins(response);              
                setFilteredLogins(response); // Initialize filtered data  
            } catch (error) {
                console.error(error);
            }
        };    
        getActiveLogins();
    }, [reloadLogins]);

    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
    };

    const handleUserSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setActiveRole(''); // Reset the active role
        const newData = logins.filter(row => {
            return row.username.toLowerCase().includes(query.toLowerCase());
        });
        setFilteredLogins(newData);
    }

    const handleUserFilter = (role) => {
        setSearchQuery('');
        if (role === 'All') {
            setFilteredLogins(logins);        
            setActiveRole(''); // Reset the active role
        } else {
            const newData = logins.filter(row => {
                return row.role.toLowerCase().includes(role.toLowerCase());
            });
            setFilteredLogins(newData);        
            setActiveRole(role); // Set the active role
        }
    }

    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    

    const handleBulkActionSubmit = async () => {
        if (selectedRows.length) {
            const sessions = selectedRows.map(item => ({
                user_id: item.user_id,
                token: item.token,
            }));

            if (bulkAction === "delete") {
                try {
                    for (const session of sessions) {
                        await apiFetch({
                            path: `/ultimate-security/v1/delete-session?user_id=${session.user_id}&token=${session.token}`,
                            method: 'GET',
                        });
                    }
                } catch (error) {
                    console.error("Error during bulk session deletion:", error);
                    alert("One or more deletions failed.");
                }

            } else {
                alert("Please select a valid action.");
            }
            setReloadLogins(Math.random());
        } else {
            alert("Please select users.");
        }
    };


    const handleClickForceLogout = async (userId, token) => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {      
            try {
                const response = await apiFetch({
                    // path: '/ultimate-security/v1/active-logins',
                    path: `/ultimate-security/v1/delete-session?user_id=${userId}&token=${token}`,
                    method: 'GET'
                });    
                setReloadLogins(Math.random());
            } catch (error) {
                console.error(error);
            }
        }       
    };

    return (
        <>
            <div className="setting-unit">
                <div className="user-datatable datatable-unit">
                    <div className="row justify-content-between mb-30">
                        <div className="col-8 filters">
                            <div className="d-flex flex-wrap wp-roles">
                                <span
                                    onClick={() => handleUserFilter('All')}
                                    className={activeRole === '' ? 'active' : ''}
                                >
                                    All
                                </span>
                                {
                                    roleList && roleList.map(item => (                                        
                                        item?.count ? 
                                        <span 
                                            key={item.role} 
                                            onClick={() => handleUserFilter(item.name)}
                                            className={activeRole === item.name ? 'active' : ''}
                                        >
                                            {item.name} 
                                            ({item.count})
                                        </span> 
                                        : null                                       
                                    ))      
                                }
                            </div>
                            <div className="bulk-action-wrapper">
                                <select value={bulkAction} name="action" onChange={handleBulkActionChange}>
                                    <option value="-1">{__('Bulk actions', 'ultimate-security')}</option>
                                    <option value="delete">{__('Delete', 'ultimate-security')}</option>
                                </select>
                                <button className="button button-secondary" onClick={handleBulkActionSubmit}>Apply</button>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="search-unit d-flex gap-2 align-items-center">
                                <input 
                                    placeholder="Search Users" 
                                    type="search" 
                                    onChange={handleUserSearch} 
                                    value={searchQuery} 
                                />
                                <button className="button button-secondary" type="button">
                                    {__('Search', 'ultimate-security')}
                                </button>
                            </div>
                        </div>
                    </div>            
                    <div className="table-wrapper">
                        <DataTable
                            columns={columns}
                            data={filteredLogins} // Use filtered data
                            selectableRows
                            onSelectedRowsChange={handleSelectedRowsChange}
                            pagination
                            paginationPerPage={5} // Default to 5 rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 25, 50]} // Options with 5 first
                            dense
                            responsive
                        />
                    </div> 
                </div> 
            </div>
        </>
    )
}
export default withForm(LoginActionLogin);